<template>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0 p-0">
                        <li class="breadcrumb-item">
                            <router-link to="/home">
                                <i class="bx bx-home-alt"></i>
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Header</li>
                    </ol>
                </nav>
                <div class="ms-auto"></div>
            </div>
            <hr/>
            <form>
                <div class="card">
                    <div class="card-body p-4">
                        <h5 class="card-title">Header Banner CMS</h5>
                        <hr />
                        <div class="form-body mt-4">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="border border-3 p-4 rounded mb-3">
                                        <div class="row mb-3" v-for="index in counter" :key="index">
                                            <div class="col-sm-6">
                                                <label class="form-label">Banner Text:</label>
                                                <input type="text" class="form-control" v-model="specificationKey[index - 1]"/>
                                            </div>
                                            <div class="col-sm-6">
                                                <label class="form-label">Link:</label>
                                                <div class="d-flex gap-2">
                                                    <input type="text" class="form-control" v-model="specificationValue[index - 1]"/>
                                                    <button v-if="counter > 1" @click="deleteSpecificationRow(index - 1)" type="button" class="btn btn-danger">X</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <button type="button" @click="addSpecification()" class="btn btn-primary">Add More</button>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div class="d-grid">
                                            <button type="button" @click="addEntity()" class="btn btn-primary">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
  
<script src='../js/header-banner-cms.js'></script>
  
  